module.exports = __webpack_public_path__ + "assets/img/Type BS (4).4aa1694e.jpg";